import {ViewBase} from "@/rawdogjs/src/core/viewBase";
import {IView} from "@/rawdogjs/src/interfaces/IView";
import {ContactStepPresenter} from "./contactStepPresenter";
import {Router} from "@/rawdogjs/src/router";
import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";

export class ContactStepView extends ViewBase implements IView {

    public _presenter: ContactStepPresenter;


    constructor(viewName: string, router: Router, dependencyContainer: ParcelDependencyContainer, presenter: ContactStepPresenter) {
        super(viewName, router, dependencyContainer);
        this._presenter = presenter;
    }

    set isSignUpButtonEnable(isEnabled: boolean) {
        if (isEnabled)
            (document.getElementById('btn-sign-up') as any).classList.remove("disabled");
        else
            (document.getElementById('btn-sign-up') as any).classList.add("disabled");

        (document.getElementById('btn-sign-up') as any).disabled = !isEnabled; //flip
    }

    get phoneNumber() {
        return this.getValueById('phone-number');
    }

    set phoneNumber(phone) {
        this.setValueById('phone-number', phone);
    }
    
    setPresenter(presenter: ContactStepPresenter) {
        this._presenter = presenter;
    }

    render(): void {
    }


}